<script>
    import XLSX from 'xlsx'
    export default {
        data () {
            return {
                file_txt:'',
                upload_arr:[],
            }
        },
        methods:{
            /**
             *
             * 使用：
             *  readXLSXfun($event){
                    let file = $event.target.files[0];
                    this.readerXLSX(file)
                }
             * 
             * [readerTXT description]
             * @param  {[type]} file [description]
             * @return {[type]}      [description]
             */
            readerTXT(file) {
                var that = this;
                var reader = new FileReader();
                reader.onload = function(e) {
                    var text = reader.result;
                    that.file_txt = text;
                }
                reader.readAsText(file, "GBK");
            },

            /**
             * 使用：
             *  readTXTfun($event){
                    let file = $event.target.files[0];
                    this.readerTXT(file)
                }
             * 
             * [readerXLSX description]
             * @param  {[type]} file [description]
             * @return {[type]}      [description]
             */
            readerXLSX(file) {
                var that = this;
                if(file && !/\.(xls|xlsx)$/.test(file.name.toLowerCase())){
                    this.$Message.error('上传格式不正确，请上传xls或者xlsx格式');
                    return false;
                }
                const fileReader = new FileReader();
                fileReader.onload = (ev) => {
                    try {
                        const data = ev.target.result;
                        const workbook = XLSX.read(data, {
                            type: 'binary'
                        });
                        const wsname = workbook.SheetNames[0];//取第一张表
                        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容
                        that.upload_arr = ws;
                        // that.peopleArr = [];//清空接收数据
                        // if(that.peopleArr.length == 1 && that.peopleArr[0].roleName == "" && that.peopleArr[0].enLine == ""){
                        //     that.peopleArr = [];
                        // }
                        //重写数据
                        
                        that.$refs.upload.value = '';

                    } catch (e) {

                        return false;
                    }
                };
                fileReader.readAsBinaryString(file);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/main-content/common-vue/readFile.vue